import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "mh_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const idx = prev.findIndex(
        (p) => p.product_id === item.product_id && p.size === item.size && p.color === item.color
      );
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + item.quantity };
        return next;
      }
      return [...prev, item];
    });
  };

  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const updateQty = (idx, qty) => setItems((prev) => prev.map((p, i) => i === idx ? { ...p, quantity: Math.max(1, qty) } : p));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
